const ROOM_TYPES = Object.freeze({
  // Unlimited projects
  PROJECT_UNLIMITED: 'PRJ',
  // Pay per use Dataroom
  DATAROOM: 'PPD',
  // "Au forfait" dataroom (alternatively called "dataroom on a plan" or on a package)
  DATAROOM_UNLIMITED: 'DR',
})

// This is a subset of ROOM_TYPES, containing only the room types that are relevant on the product scope
// This is used for tracking purposes, for example. But is also used in multiple properties shared across types
const PRODUCT_ROOM_TYPES = Object.freeze({
  DATAROOM: 'DR',
  LEGAL_PROJECT: 'LP',
})

export { ROOM_TYPES, PRODUCT_ROOM_TYPES }
